interface MessageExternalLinkProps {
  url: string;
  className?: string;
}

export function MessageExternalLink({ url, className = "" }: MessageExternalLinkProps) {
  return (
    <a
      className={`message-link${className ? ` ${className}` : ""}`}
      href={url}
      target="_blank"
      rel="noopener noreferrer nofollow ugc"
    >
      Mesaj bağlantısını aç <span aria-hidden="true">↗</span>
    </a>
  );
}
